export default "__VITE_ASSET__Ck85_ZHV__"